// extracted by mini-css-extract-plugin
module.exports = {"skillContainer":"Container_skillContainer__3h3km","heading":"Container_heading__zj_6V","years":"Container_years__1B6c_"};